var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"contents",attrs:{"id":"contents"}},[_c('content-title'),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }